import api from "@/lib/api";
import { toast } from "sonner";

export const HOLIDAY_TYPES = {
  public: { label: "Public", chip: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "bg-indigo-500" },
  optional: { label: "Optional", chip: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  company: { label: "Company", chip: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
};

export const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const monthLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString(undefined, { month: "long", year: "numeric" });
};

export const dayLabel = (iso, opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" }) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, opts);
};

export const todayIso = () => new Date().toLocaleDateString("en-CA");

export async function downloadFile(path, fallback) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallback;
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch { toast.error("Download failed"); }
}
